import { Injector } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { deriveLoading } from 'ngxtension/derive-loading';
import {
  ObservableSignal,
  toObservableSignal,
} from 'ngxtension/to-observable-signal';
import { Observable } from 'rxjs';

/** Archive Result Count. */
export class ArchiveResultCount {
  /** Archive ID. */
  archiveId: number;
  /** Archive name. */
  archiveName: string;
  /**
   * Search Result count.
   *
   * Value of undefined indicates that the count is not yet available.
   */
  count: ObservableSignal<number | undefined>;
  /** Current loading state for the count. */
  loading$: Observable<boolean>;
  /** whether this archive is the current active one. */
  isActive: boolean;

  constructor(
    injector: Injector,
    archiveId: number,
    archiveName: string,
    isActive: boolean,
    countQuery$: Observable<number>
  ) {
    this.archiveId = archiveId;
    this.archiveName = archiveName;
    this.isActive = isActive;
    this.loading$ = countQuery$.pipe(deriveLoading());
    this.count = toObservableSignal(
      toSignal(countQuery$, { initialValue: undefined, injector: injector }),
      { injector: injector }
    );
  }
}
